// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__30wyh","file":"styles_file__pOkYz"};